import React from "react";

import type { DashboardWidgetSpecInitConfig } from "../../common/dashboard-spec";
import { DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { AddToDashboardContent } from "./_add-to-dashboard-content";

export type AddToDashboardDrawerState = ReadonlyArray<DashboardWidgetSpecInitConfig>;

export interface AddToDashboardDrawerProps {
	when: undefined | AddToDashboardDrawerState;
}

export const AddToDashboardDrawer: React.FC<AddToDashboardDrawerProps> = ({ when }) => (
	<ExplorationDrawer headerTitle={<DrawerTitle title="Add to dashboard..." />} layout="compact" when={when}>
		{(state, close) => <AddToDashboardContent close={close} widgets={state} />}
	</ExplorationDrawer>
);
